import type { FC } from "react";
import React from "react";
import { FormGroup, FormControlLabel, Checkbox } from "@mui/material";
import { withStyles } from "@mui/styles";
import checkbox from "../../styles/checkbox";

const StyledCheckbox = withStyles(checkbox)(Checkbox);
export type Props = {
  checked: boolean;
  disabled?: boolean;
  label: string;
  onChange: (arg0: boolean) => unknown;
};

const CheckBox: FC<Props> = ({ checked, label, onChange, disabled }) => (
  <FormGroup>
    <FormControlLabel
      disabled={disabled}
      control={
        <StyledCheckbox
          checked={checked}
          onChange={(e) => onChange(e.target.checked)}
          data-testid={`${label}-checkbox`}
        />
      }
      label={label}
    />
  </FormGroup>
);

export default CheckBox;
